'use client';
import { useEffect } from 'react';
import { useAuth } from '~/auth/hooks';

export const InitAuth = () => {
  const { checkSignedIn } = useAuth();

  useEffect(() => {
    checkSignedIn();
  }, []);

  return null;
};
